// Module
var code = "<fc-icon params=\"name: 'drag-arrow', width: 6, height: 16\"></fc-icon>\n";
// Exports
module.exports = code;